import type { Config, CreateConnectorFn } from '@wagmi/vue'
import { cookieStorage, createConfig, createStorage, http } from '@wagmi/vue'
import { base } from 'viem/chains'
import { appDescription, appName } from '../constants'

const icons = ['https://app.itsavow.com/maskable-icon.png' as const]
export const metadata = {
  name: appName,
  description: appDescription,
  url: 'https://app.itsavow.com',
  icons,
} as const

export const chains = [base] as const

function getRpcUrl(): string | undefined {
  if (import.meta.server || import.meta.client) {
    try {
      const config = useRuntimeConfig()
      return config.public.baseNodeUrl || undefined
    }
    catch {
      return undefined
    }
  }
  return undefined
}

export function createAvowWagmiConfig(connectors?: CreateConnectorFn[]) {
  const rpcUrl = getRpcUrl()
  return createConfig({
    chains: [base],
    ssr: true,
    connectors,
    storage: createStorage({
      storage: cookieStorage,
    }),
    transports: {
      [base.id]: http(rpcUrl),
    },
  })
}

export function createMinimalWagmiConfig() {
  return createAvowWagmiConfig()
}

let fullConfigPromise: Promise<Config> | null = null
export async function getFullWagmiConfig(): Promise<Config> {
  fullConfigPromise ??= import('@wagmi/vue/connectors').then(({ baseAccount }) => {
    const connectors = [
      baseAccount({
        appName: metadata.name,
        appLogoUrl: metadata.icons[0],
        preference: {
          telemetry: false,
        },
      }),
    ]
    return createAvowWagmiConfig(connectors)
  })
  return fullConfigPromise
}

export function createClientWagmiConfig() {
  return createMinimalWagmiConfig()
}

export function createServerWagmiConfig() {
  return createMinimalWagmiConfig()
}
